/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignPipelineConfigDataSchema = z.object({
	campaignId: z.string(),
	stages: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			position: z.number(),
			locked: z.boolean().default(false),
			type: z.string().nullable(),
		}),
	),
	candidateCounts: z.record(z.string(), z.number()),
	isArchived: z.boolean(),
	source: z.string().default('campaign'),
	isCustomized: z.boolean().default(true),
})

export type CampaignPipelineConfigDataSchema = z.infer<typeof campaignPipelineConfigDataSchema>
